//  RoomSlots.js  ------------------------------------------
import { useDrop } from 'react-dnd';
import './RoomSlots.css';
import { isoAPixels } from '../utils/isoSize';

export default function RoomSlots({ slots, setSlots, setShowDeckPrompt, setWasArtDropped, style = {} }) {
  /* slotIds = ['slotA','slotB','slotC'] */
  return (
    <div
        style={{
            position:'relative',
            width: 400,
            height: 300,
        }}
    >
      {Object.entries(slots).map(([slotId, art]) => (
        <WallSlot
          key={slotId}
          id={slotId}
          art={art}
          onDrop={(item) => {
            setSlots((s) => ({ ...s, [slotId]: item.art }));
            setShowDeckPrompt(false);
            setWasArtDropped(true);
          }}
        />
      ))}
    </div>
  );
}

function WallSlot({ id, art, onDrop }) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: 'ART_CARD',
      drop: onDrop,
      collect: (m) => ({ isOver: !!m.isOver() }),
    }),
    [onDrop],
  );

  /* positions hard-coded in design-coords (px) */
  const pos = {
    slotA: { top: 150, left: 100 },
    slotB: { top: 150, left: 400 },
    slotC: { top: 150, left: 700 },
  }[id];

  const { width: SLOT_W, height: SLOT_H } = isoAPixels('A3', 18);

  return (
    <div
      ref={drop}
      className="wall-slot"
      style={{
        ...pos,
        width: SLOT_W,
        height: SLOT_H,
        border: isOver ? '2px dashed #ffce00' : '6px solid #000',
      }}
    >
      {art ? (
        <img src={art.img} alt={art.name} style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            filter: 'none',
          }}/>
      ) : (
        <span>drag art&nbsp;here</span>
      )}
    </div>
  );
}
